import { oc } from '@orpc/contract';
import { commonScenariosInputSchema, commonScenariosOutputSchema } from '../schemas/compare.schemas.js';
export const getCommonScenariosContract = oc
    .route({
    method: 'POST',
    path: '/compare/common-scenarios',
    tags: ['Compare'],
    summary: 'Scenarios where every picked vehicle already has at least one valid run',
    description: 'The shortlist step of the compare screen (plan §7): only scenarios every selected vehicle has proven — a VALID or VALID_WITH_WARNING run under — can be compared, and each is returned with the per-vehicle valid-run count and mean. A POST because the vehicle list is the request body, not a path.',
})
    .input(commonScenariosInputSchema)
    .output(commonScenariosOutputSchema);
//# sourceMappingURL=get-common-scenarios.contract.js.map